/** @module FashionInspiration */
define([
], function() {

	return {
		
	};
});
